import axios from "axios";

// const baseURL = `${process.env.REACT_APP_BASE_URL}/api/v1`
const baseURL = `${process.env.REACT_APP_LOCAL_BASE_URL}`;
// alert(baseURL)
// const socket_url = `${process.env.REACT_APP_LOCAL_BASE_URL}`
const socket_url = `${process.env.REACT_APP_BASE_URL}`;

// Create axios instance
const axiosInstance = axios.create();

// Add response interceptor to handle token expiration and duplicate meeting switch prompts
axiosInstance.interceptors.response.use(
  async (response) => {
    // If the response indicates the user has already joined the session
    if (response.data && response.data.success && response.data.alreadyJoined) {
      if (typeof window !== "undefined") {
        const confirmSwitch = window.confirm("You have already joined this session in another tab or device. Would you like to switch to this tab?");
        if (confirmSwitch) {
          const originalConfig = response.config;
          
          if (originalConfig.method && originalConfig.method.toUpperCase() === 'POST') {
            // Handle POST body (e.g. for guest join)
            if (typeof originalConfig.data === 'string') {
              try {
                const parsed = JSON.parse(originalConfig.data);
                parsed.force = true;
                originalConfig.data = JSON.stringify(parsed);
              } catch (e) {
                const separator = originalConfig.url.includes("?") ? "&" : "?";
                originalConfig.url = `${originalConfig.url}${separator}force=true`;
              }
            } else if (originalConfig.data && typeof originalConfig.data === 'object') {
              originalConfig.data.force = true;
            } else {
              const separator = originalConfig.url.includes("?") ? "&" : "?";
              originalConfig.url = `${originalConfig.url}${separator}force=true`;
            }
          } else {
            // Handle GET query (for logged-in user / coach join)
            const separator = originalConfig.url.includes("?") ? "&" : "?";
            originalConfig.url = `${originalConfig.url}${separator}force=true`;
          }
          
          // Resend the request with force=true
          return axiosInstance(originalConfig);
        } else {
          // Return cancelled status
          return { data: { success: false, error: "Switch cancelled", cancelled: true } };
        }
      }
    }
    return response;
  },
  (error) => {
    // Handle 401 Unauthorized errors (token expired)
    if (error.response && error.response.status === 401) {
      // Clear token from localStorage
      localStorage.removeItem("token");
      localStorage.removeItem("completedSteps");

      // Clear any other auth-related data
      sessionStorage.removeItem("path");
      sessionStorage.removeItem("follow_id");

      // Show user-friendly message
      if (typeof window !== "undefined") {
        // Only show toast if we're in browser environment
        const { toast } = require("react-toastify");
        toast.error("Your session has expired. Please login again.");

        // Redirect to login page
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

const api = async (url = "", method, data = {}) => {
  const options = {
    method,
    headers: {
      "content-type": "application/json",
      token: localStorage.getItem("token"),
      "Cache-Control": "no-store, no-cache, must-revalidate, proxy-revalidate",
      "x-timezone": Intl.DateTimeFormat().resolvedOptions().timeZone,
      "timezone": Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
    data,
    url: `${baseURL}/${url}`,
  };
  return axiosInstance(options);
};

const formDataAPI = (url = "", method, data = {}) => {
  const options = {
    method,
    headers: {
      // Don't set content-type for FormData - let browser set it with boundary
      token: localStorage.getItem("token"),
      "Cache-Control": "no-store, no-cache, must-revalidate, proxy-revalidate",
      "x-timezone": Intl.DateTimeFormat().resolvedOptions().timeZone,
      "timezone": Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
    data,
    url: `${baseURL}/${url}`,
  };
  return axiosInstance(options);
};

const urlEncodedAPI = (url = "", method, data = {}) => {
  let payload = data;
  try {
    if (data instanceof FormData) {
      payload = new URLSearchParams();
      for (const [k, v] of data.entries()) payload.append(k, v);
    } else if (data && typeof data === "object") {
      payload = new URLSearchParams();
      Object.entries(data).forEach(([k, v]) => {
        if (v !== undefined && v !== null) payload.append(k, v);
      });
    }
  } catch (e) {
    // fallback: send as-is
  }
  const options = {
    method,
    headers: {
      "content-type": "application/x-www-form-urlencoded",
      token: localStorage.getItem("token"),
      "Cache-Control": "no-store, no-cache, must-revalidate, proxy-revalidate",
      "x-timezone": Intl.DateTimeFormat().resolvedOptions().timeZone,
      "timezone": Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
    data: payload,
    url: `${baseURL}/${url}`,
  };
  return axiosInstance(options);
};

export { api, formDataAPI, urlEncodedAPI, socket_url };
